import React, { Component } from "react";
import CalendarPicker from "rc-calendar";
import "rc-calendar/dist/rc-calendar.css";
//import List from '../../Elements/List/List';
import ArtistsList from "../../Elements/ArtistsList/ArtistsList";
import LeftMenu from "../../Elements/LeftMenu/LeftMenu";
//import RightMenu from '../../Elements/RightMenu/RightMenu';
import Artist from "../../Elements/Artist/Artist";
import News from "../../Elements/News/News";
import Calendar from "../../Elements/Calendar/Calendar";
import Article from "../../Elements/Article/Article";
import About from "../../Elements/About/About";
import CyberRepo from "../../Elements/CyberRepo";
import Multimedia from "../../Elements/Multimedia/Multimedia";
import MediaViewer from "../../Elements/MediaViewer"
import MultimediaItem from "../../Elements/MultimediaItem/MultimediaItem";
//import EditionsList from '../../Elements/EditionsList/EditionsList';
//import List2 from '../../Elements/List2/List2';
import NewsList from "../../Elements/NewsList/NewsList";
//import Education1 from '../../Elements/Education/Education1';
import ViewType1 from "../../Elements/View_type_1";
import ViewType2 from "../../Elements/View_type_2";
import ViewType3 from "../../Elements/View_type_3";
import ViewType4 from "../../Elements/View_type_4";
import ViewType5 from "../../Elements/View_type_5";
import ViewType6 from "../../Elements/View_type_6";
import ViewType7 from "../../Elements/View_type_7";
import ViewType8 from "../../Elements/View_type_8";
import ViewType9 from "../../Elements/View_type_9";
import ViewType10 from "../../Elements/View_type_10";
import ViewType11 from "../../Elements/View_type_11";
import ViewType12 from "../../Elements/View_type_12";
import ViewType13 from "../../Elements/View_type_13";
import ViewType14 from "../../Elements/View_type_14";
import ViewType15 from "../../Elements/View_type_15";
import ViewType16 from "../../Elements/View_type_16";
import ViewType17 from "../../Elements/View_type_17";
import ViewType18 from "../../Elements/View_type_18";
import ViewType19 from "../../Elements/View_type_19";
import ViewType20 from "../../Elements/View_type_20";
import ViewType21 from "../../Elements/View_type_21";
import ViewType22 from "../../Elements/View_type_22";
import ViewType23 from "../../Elements/View_type_23";
import ViewType24 from "../../Elements/View_type_24";
import ViewType25 from '../../Elements/View_type_25'
import ViewType26 from "../../Elements/View_type_26";
import ViewType25Vote from "../../Elements/view_type_25_vote";

export default class Middle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            config: props.config,
            middleUrl: props.middleUrl
        };
    }

    render() {
        var left_menu_element = (
            <LeftMenu
                data={
                    Array.isArray(this.state.data) ? this.state.data[0] : this.state.data
                }
            />
        );

        switch (this.state.config.middle_component) {
            case "view_type_1":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType1 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_2":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType2 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_3":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center">
                                <ViewType3 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_4":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType4 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_20":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType20 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_5":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType5 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_6":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType6 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_7":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType7 data={this.state.data} middleUrl={this.state.middleUrl} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_8":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                                <ViewType8 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_9":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType9 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_10":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType10 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_11":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center">
                                <ViewType11 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_12":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType12 data={this.state.data} config={this.state.config} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_13":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType13 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_14":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType14 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_15":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType15 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_16":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType16 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_17":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType17 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_18":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType18 data={this.state.data} config={this.state.config} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_19":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType19 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_21":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType21 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_22":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType22 data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_23":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType23 data={this.state.data} middleUrl={this.state.middleUrl} />
                            </div>
                        </div>
                    </section>
                );
            case "view_type_24":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <ViewType24 data={this.state.data} middleUrl={this.state.middleUrl} />
                            </div>
                        </div>
                    </section>
                );

            case "view_type_25":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-10 col-lg-10 mobile-no-padding">
                                <ViewType25 data={this.state.data} config={this.state.config} middleUrl={this.state.middleUrl} />
                            </div>
                        </div>
                    </section>
                );

            case "view_type_25_vote":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-10 col-lg-10 mobile-no-padding">
                                <ViewType25Vote data={this.state.data} config={this.state.config} middleUrl={this.state.middleUrl} />
                            </div>
                        </div>
                    </section>
                );

            case "view_type_26":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-12 col-md-10 col-lg-10">
                                <ViewType26 data={this.state.data} middleUrl={this.state.middleUrl} />
                            </div>
                        </div>
                    </section>
                );

            case "media_viewer":
                return (
                    <section className="content_middle">
                        {this.state.data.horizontal ? (
                            <div className="container">
                                <div className="center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <MediaViewer data={this.state.data} />
                                </div>
                            </div>
                        ) : (
                            <div className="container">
                                <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                    {left_menu_element}
                                </div>
                                <div className="center col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                    <MediaViewer data={this.state.data} />
                                </div>
                            </div>
                        )}

                    </section>
                );

            /*ArtistsList*/
            case "artists":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center">
                                <ArtistsList data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );

            /*Multimedia*/
            case "multimedia":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-9 col-md-9 col-lg-9 ">
                                <Multimedia data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            /*Multimedia item*/
            case "multimedia_item":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-9 col-md-9 col-lg-9">
                                <MultimediaItem data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            /*Article*/
            case "article":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                <Article data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            /*O festiwalu ABOUT*/
            case "about":
                return (
                    <section className="content_middle">
                        <div className="container aboutcont-wrapper">
                            <div className="left col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 extended-box">
                                <About data={this.state.data} config={this.state.config} />
                            </div>
                        </div>
                    </section>
                );

            case "news_list":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <NewsList data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "newslist":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <NewsList data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            case "calendar":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                <Calendar data={this.state.data} config={this.state.config} />
                            </div>
                            <div className="right col-xs-3 col-sm-3 col-md-3 col-lg-3">
                                <CalendarPicker />
                            </div>
                        </div>
                    </section>
                );
            /*Artist*/
            case "artist":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <Artist data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );

            /*News*/
            case "news":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-9 col-md-9 col-lg-9">
                                <News data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            /*Sponsors*/
            case "sponsors":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                {left_menu_element}
                            </div>
                            <div className="center col-xs-12 col-sm-9 col-md-9 col-lg-9">
                                <Article data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
            /*Sponsors*/
            case "repository":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <CyberRepo data={this.state.data} bgColor={this.state.config.gbcolor} />
                            </div>
                        </div>
                    </section>
                );
            /*Artist*/
            /*case "artist":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="hidden-xs col-sm-12 col-md-3 col-lg-3">
                                <LeftMenu data={this.state.data}/>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <Artist data={this.state.data}/>
                            </div>
                        </div>
                      </section>
                );
            /*Calendar*/
            /*case "calendar":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="hidden-xs col-sm-3 col-md-3 col-lg-3">
                                <LeftMenu data={this.state.data}/></div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                <Calendar data={this.state.data} config={this.state.config}/>
                            </div>
                            <div className="right col-xs-3 col-sm-3 col-md-3 col-lg-3">
                                <CalendarPicker />
                            </div>
                        </div>
                      </section>
                );

            /*EditionsList*/
            /*case "editions_list":
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="left hidden-xs col-sm-3 col-md-3 col-lg-3">
                                <LeftMenu data={this.state.data}/>
                            </div>
                            <div className="center col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                <EditionsList data={this.state.data}/>
                            </div>
                        </div>
                      </section>
                );*/

            /*catalog_main*/
            /*case "catalog_main":
                    return (
                        <section className="content_middle">
                            <div className="container">
                                <div className="left hidden-xs col-sm-3 col-md-3 col-lg-3">
                                    <LeftMenu data={this.state.data}/>
                                </div>
                                <div className="center col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                    <List2 data={this.state.data}/>
                                </div>
                                <div className="right col-xs-3 col-sm-3 col-md-3 col-lg-3">
                                    <RightMenu data={this.state.data}/>
                                    <CalendarPicker />
                                </div>
                            </div>
                          </section>
                    );


                    case "collection-history":
                        return (
                            <section className="content_middle">
                                <div className="container">
                                    <div className="left hidden-xs col-sm-3 col-md-3 col-lg-3">
                                        <LeftMenu data={this.state.data}/>
                                    </div>
                                    <div className="center col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                        <News data={this.state.data}/>
                                    </div>
                                    <div className="right col-xs-3 col-sm-3 col-md-3 col-lg-3">

                                    </div>
                                </div>
                              </section>
                        );

                    case "collection-online":
                                return (
                            <section className="content_middle">
                                <div className="container">
                                    <div className="left hidden-xs-2 col-sm-2 col-md-2 col-lg-2">
                                        <LeftMenu data={this.state.data}/>
                                    </div>
                                    <div className="center col-xs-10 col-sm-10 col-md-10 col-lg-10">
                                        <News data={this.state.data}/>
                                    </div>
                                </div>
                            </section>
                        );*/

            default:
                return (
                    <section className="content_middle">
                        <div className="container">
                            <div className="center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <NewsList data={this.state.data} />
                            </div>
                        </div>
                    </section>
                );
        }
    }
}


// WEBPACK FOOTER //
// ./src/Components/Content/Middle/index.js